import _ from 'underscore';

export const getToolbarFacade = ({ view, isForVNext }) => {
  const currentToolbar = isForVNext ?
    view.toolbar.gridToolbarGroup.toolbarWithName() :
    view.toolbar.gridToolbarGroup.toolbars['default-toolbar'];

  const updateButtonConfig = ({ itemId, toolbarConfig }) => {
    if (isForVNext) {
      currentToolbar.update({ id: itemId, ...toolbarConfig });
    } else {
      const itemConfig = _.findWhere(currentToolbar.get().items, { id: itemId });
      if (itemConfig) {
        const newToolbarConfig = _.extend({}, itemConfig, toolbarConfig);
        currentToolbar.update(newToolbarConfig);
      }
    }
  };

  return {
    currentToolbar,
    updateButtonConfig,
  };
};

